import { cn } from "@/lib/utils";
import type { RequestStatus } from "@/pages/modules/fam-match/types";

export function SessionBadge({ status }: { status: RequestStatus }) {
  const map: Record<RequestStatus, { label: string; tint: string }> = {
    open:      { label: "配對中",  tint: "bg-sky-100 text-sky-800" },
    assigned:  { label: "已指派",  tint: "bg-amber-100 text-amber-800" },
    confirmed: { label: "已確認",  tint: "bg-emerald-100 text-emerald-800" },
    completed: { label: "已完成",  tint: "bg-zinc-100 text-zinc-700" },
    declined:  { label: "已婉拒",  tint: "bg-rose-100 text-rose-800" },
    withdrawn: { label: "已撤回",  tint: "bg-zinc-100 text-zinc-700" },
  };
  const m = map[status];
  return (
    <span
      className={cn(
        "shrink-0 rounded-full px-2.5 py-0.5 text-[11px] font-medium",
        m.tint,
      )}
    >
      {m.label}
    </span>
  );
}
